define('AwaLabs.WebReviews', [
    'WebReviews.Rating.Abbreviation.View',
    'WebReviews.Rating.View',
    'WebReviews.Reviews'
], function AwaLabsWebReviews(
    WebReviewsRatingAbbreviationView,
    WebReviewsRatingView,
    WebReviewsReviews
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var plp = container.getComponent('PLP');
            var pdp = container.getComponent('PDP');
            var environment = container.getComponent('Environment');
            var config = environment.getConfig('WebReviews');

            if (plp) {
                plp.addChildViews(
                    plp.PLP_VIEW, {
                        'WebReviews.Rating': function WebReviewsRatingChildView() {
                            return new WebReviewsRatingAbbreviationView({
                                plp: plp,
                                application: container,
                                config: config
                            });
                        }
                    }
                );
            }

            if (pdp) {
                pdp.addChildViews(
                    pdp.PDP_FULL_VIEW, {
                        'WebReviews.Rating': function WebReviewsRatingChildView() {
                            return new WebReviewsRatingView({
                                pdp: pdp,
                                application: container,
                                config: config
                            });
                        },
                        'WebReviews.Reviews': function WebReviewsReviewsChildView() {
                            return new WebReviewsReviews({
                                pdp: pdp,
                                application: container,
                                config: config
                            });
                        }
                    },
                    pdp.PDP_QUICK_VIEW, {
                        'WebReviews.Rating': function WebReviewsRatingChildView() {
                            return new WebReviewsRatingView({
                                pdp: pdp,
                                application: container,
                                config: config
                            });
                        }
                    }
                );
            }
        }
    };
});
